module.exports = __webpack_public_path__ + "img/book5.8b9b37c2.jpg";